var render, staticRenderFns
import script from "./integral_goods_off_shelves.vue?vue&type=script&lang=js"
export * from "./integral_goods_off_shelves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745b646b')) {
      api.createRecord('745b646b', component.options)
    } else {
      api.reload('745b646b', component.options)
    }
    
  }
}
component.options.__file = "found/views/mall/views/integral_mall_management/integral_goods_off_shelves/integral_goods_off_shelves.vue"
export default component.exports